export default __webpack_public_path__ + "static/media/Poppinsbold.24051d31.woff";